import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQProps {
  question: string;
  answer: string;
  value: string;
}

const FAQList: FAQProps[] = [
  {
    question: "Which cryptocurrency exchanges does Doyen support?",
    answer: "Doyen supports all major US-regulated exchanges including Coinbase, Kraken, Gemini, Binance US, and Crypto.com. You can connect multiple exchanges through a single unified interface.",
    value: "item-1",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept traditional payment methods (credit/debit cards) and cryptocurrency payments (Bitcoin and Monero with more to come). Crypto payments provide the option for completely anonymous accounts with auto-generated usernames and passwords for maximum privacy.",
    value: "item-2",
  },
  {
    question: "What is the product pricing structure?",
    answer: "The Premium license includes one year of updates. Optional subscription features may be added in the future, but your plan benefits are locked in. Once your year of updates expires, you will be able to continue using the last version you received (or any previous version.) We will not move features from the Free version to Premium version or from Premium to subscription-only.",
    value: "item-4",
  },  {
    question:
      "What makes Doyen's depth of book special?",
    answer:
      "Doyen features the most advanced and customizable depth of book available for cryptocurrency trading, with real-time updates, advanced filtering, and the ability to view multiple exchanges simultaneously. This allows traders to make informed decisions based on comprehensive market data.",
    value: "item-5",
  },  {
    question: "How does the anonymous account feature work?",
    answer: "When you pay with cryptocurrency we automatically generate a unique username and secure password for your account. No personal information is required or stored, ensuring complete trading privacy while maintaining full platform functionality.",
    value: "item-6",
  },
  {
    question: "How do I connect my exchange accounts to Doyen?",
    answer: "Connecting your exchanges is simple and secure. You'll need API keys from each exchange you want to use. Check our comprehensive Setup page or use the in-app Setup instructions (located in each exchange's settings menu) for step-by-step instructions.",
    value: "item-7",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      className="container py-24 sm:py-32"
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        Frequently Asked{" "}
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          Questions
        </span>
      </h2>

      <Accordion
        type="single"
        collapsible
        className="w-full AccordionRoot"
      >
        {FAQList.map(({ question, answer, value }: FAQProps) => (
          <AccordionItem
            key={value}
            value={value}
          >
            <AccordionTrigger className="text-left">
              {question}
            </AccordionTrigger>

            <AccordionContent>{answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <h3 className="font-medium mt-4">
        Still have questions?{" "} <br/>
        <text className="text-primary">contact@doyentrading.com</text>
      </h3>
    </section>
  );
};
